export default __webpack_public_path__ + "take-me-fishing-logo-94a883d52684024767c91b9482bfd1f9.png";